export const JOURS = ['Lun','Mar','Mer','Jeu','Ven','Sam','Dim']
export const MOIS_LONG = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre']
export const MOIS_FR = ['jan','fév','mar','avr','mai','jun','jul','aoû','sep','oct','nov','déc']

export const EMOJIS_DEFIS = [
  '🗣️','🤝','🧹','✋','🪥','📚','✏️','🌟','🎯','💪',
  '🏃','🎨','🍎','🛏️','👂','😊','🙏','🎒','📖','🧠',
  '🌈','⚡','🔥','💡','🏆','🫶','👍','🦁','🐯','🚀',
  '🌸','🎵','🎸','⚽','🏀','🎾','🧘','🫁','💬','🤫',
  '🧡','💛','💚','💙','💜','❤️','🌻','🌊','🦋','🐝',
  '🍀','🌙','☀️','⭐','🎪','🏅','🥇','🎖️','📝','🔑',
  '🧲','🪄','🎭','🤸','🏋️','🧗','🚴','🛹','🎮','🖍️',
]
export const EMOJIS_RECOMP = [
  '🎁','🃏','👾','⚽','🧩','❤️','🍕','🎪','🏆','🎨',
  '📚','🎯','🌟','🛍️','🎠','🎭','🎬','🌺','🍦','🍫',
  '🎡','🎢','🎠','🎟️','🎲','🎳','🎻','🎹','🥁','🎺',
  '🏄','🧗','🚵','🛼','⛸️','🎿','🏊','🤿','🏇','🚀',
  '🌈','🦄','🐉','🦊','🐬','🦅','🌸','🌴','🏖️','🏔️',
  '🍰','🎂','🍩','🧁','🍭','🍬','🥤','🍿','🥞','🌮',
  '📷','🎙️','🎧','🖥️','📱','🔭','🔬','🎈','🎉','🎊',
]

export const DEFIS_MAISON_DEFAUT = [
  { label: 'Voix adaptée', points: 2, emoji: '🗣️', type: 'maison' },
  { label: 'Collaborer', points: 1, emoji: '🤝', type: 'maison' },
  { label: 'Ranger', points: 1, emoji: '🧹', type: 'maison' },
  { label: 'Gestes adaptés', points: 2, emoji: '✋', type: 'maison' },
  { label: 'Soins personnels', points: 1, emoji: '🪥', type: 'maison' },
]

export const DEFIS_ECOLE_DEFAUT = [
  { label: 'Comportement en classe', points: 2, emoji: '📚', type: 'ecole' },
  { label: 'Travail accompli', points: 2, emoji: '✏️', type: 'ecole' },
  { label: 'Respect des règles', points: 1, emoji: '🌟', type: 'ecole' },
]

export const RECOMPENSES_DEFAUT = [
  { label: 'Cartes Pokémon', points: 20, emoji: '🃏' },
  { label: 'Figurine Among Us', points: 30, emoji: '👾' },
  { label: 'Tournoi de sport', points: 25, emoji: '⚽' },
  { label: 'Nouveau puzzle', points: 35, emoji: '🧩' },
  { label: 'Temps spécial en famille', points: 15, emoji: '❤️' },
]

// Retourne le lundi de la semaine contenant la date
export const lundiDe = (date) => {
  const d = new Date(date)
  const day = d.getDay()
  d.setDate(d.getDate() - ((day + 6) % 7))
  d.setHours(0,0,0,0)
  return d
}

export const semaineCourante = () => { const d = lundiDe(new Date()); return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0') }

export const decalerSemaine = (iso, n) => {
  const d = new Date(iso)
  d.setDate(d.getDate() + n * 7)
  return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0')
}

export const formatSemaine = (iso) => {
  const lundi = new Date(iso)
  const dimanche = new Date(iso)
  dimanche.setDate(dimanche.getDate() + 6)
  const mL = MOIS_LONG[lundi.getMonth()]
  const mD = MOIS_LONG[dimanche.getMonth()]
  const annee = dimanche.getFullYear()
  if (lundi.getMonth() === dimanche.getMonth())
    return `du ${lundi.getDate()} au ${dimanche.getDate()} ${mL} ${annee}`
  return `du ${lundi.getDate()} ${mL} au ${dimanche.getDate()} ${mD} ${annee}`
}

export const labelCourtSemaine = (iso) => {
  const lundi = new Date(iso)
  const dimanche = new Date(iso)
  dimanche.setDate(dimanche.getDate() + 6)
  return `${lundi.getDate()}-${dimanche.getDate()} ${MOIS_FR[dimanche.getMonth()]}`
}

export const defiActifPourSemaine = (defi, semaine) => {
  if (!defi.actif) return false
  if (!defi.debut_semaine) return true
  return semaine >= defi.debut_semaine
}

export const prochainLundi = () => {
  const d = lundiDe(new Date())
  d.setDate(d.getDate() + 7)
  return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0')
}
